import { createApp } from 'vue'
import Layout from './Layout.vue'
import router from './router'
import store from './vuex/store.js'
import { createAccessGuard } from './services/authorization/ModuleAccess'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, md } from 'vuetify/iconsets/md'
import 'vuetify/styles'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './assets/app.css'

const vuetify = createVuetify({
  components,
  directives,
  defaults: {
    VTextField: { variant: 'outlined', density: 'comfortable', color: 'primary' },
    VTextarea: { variant: 'outlined', density: 'comfortable', color: 'primary' },
    VSelect: { variant: 'outlined', density: 'comfortable', color: 'primary' },
    VAutocomplete: { variant: 'outlined', density: 'comfortable', color: 'primary' },
    VCard: { rounded: 'lg' }
  },
  icons: {
    defaultSet: 'md',
    aliases,
    sets: {
      md
    }
  },
  theme: {
    defaultTheme: localStorage.getItem('theme') || 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#F6F8FA',
          surface: '#FFFFFF',
          'surface-variant': '#E7EEF3',
          primary: '#1867C0',
          'primary-darken-1': '#1F5592',
          secondary: '#487A78',
          'secondary-darken-1': '#2F5F5D',
          error: '#B00020',
          info: '#1976D2',
          success: '#2E7D32',
          warning: '#ED6C02',
          'on-primary': '#FFFFFF',
          'on-secondary': '#FFFFFF',
          'on-surface': '#1F2933'
        }
      },
      dark: {
        dark: true,
        colors: {
          background: '#121416',
          surface: '#1B1F23',
          'surface-variant': '#303840',
          primary: '#90CAF9',
          'primary-darken-1': '#0D3557',
          secondary: '#80CBC4',
          'secondary-darken-1': '#4DB6AC',
          error: '#FFB4AB',
          info: '#90CAF9',
          success: '#81C784',
          warning: '#FFB74D',
          'on-primary': '#0D3557',
          'on-secondary': '#123634',
          'on-surface': '#E6EDF3'
        }
      }
    }
  }
})

router.beforeEach(createAccessGuard(store))

window.addEventListener('focus', () => {
  if (store.getters['authModule/isAuthenticated']) store.dispatch('authModule/validate').catch(() => {})
})

createApp(Layout)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
